// extracted by mini-css-extract-plugin
module.exports = {"customHeightFix":"ExpressionSeverityCard_customHeightFix__3h0b2","cardSubHeader":"ExpressionSeverityCard_cardSubHeader__3FbE3"};